import { Constants } from '@constants';
import { TAccount } from '@helpers/Accounts/accounts.types';
import { TFormalOffer } from '@helpers/FormalOffers/formalOffers.types';

export const isSelectedAmountValid = (
    selectedAmount: number,
    selectedOffer: TFormalOffer | null
) => {
    if (!selectedOffer) return false;

    // Cashless offers have an available_cash of 0, so the selected amount is always valid
    if (selectedOffer.is_repayment_reduction) return true;

    const maxAvailableCash = selectedOffer.available_cash!;

    return isSelectedAmountLessThanMaxAvailableCashAndMoreThanMinDrawdown(
        selectedAmount,
        maxAvailableCash
    );
};

export const isSelectedAmountValidForAccessPeriod = (
    selectedAmount: number,
    accessPeriod: TAccount['formal_offer_access_period']
) => {
    if (!accessPeriod) return false;

    const maxAvailableCash = accessPeriod.available_cash!;

    return isSelectedAmountLessThanMaxAvailableCashAndMoreThanMinDrawdown(
        selectedAmount,
        maxAvailableCash
    );
};

export const selectedAmountGreaterThanMaxAvailableCash = (
    selectedAmount: number,
    maxAvailableCash: number
) => {
    return selectedAmount > maxAvailableCash;
};

export const selectedAmountLessThanMinDrawDown = (selectedAmount: number) => {
    return selectedAmount < Constants.MIN_DRAW_DOWN_AMOUNT;
};

const isSelectedAmountLessThanMaxAvailableCashAndMoreThanMinDrawdown = (
    selectedAmount: number,
    maxAvailableCash: number
) => {
    return (
        !selectedAmountGreaterThanMaxAvailableCash(
            selectedAmount,
            maxAvailableCash
        ) && !selectedAmountLessThanMinDrawDown(selectedAmount)
    );
};
